// Check the saved fields, never the display name or localStorage flags.
export function hasTableParticipationProfile(user) {
  const firstName = user?.profile?.firstName;
  const lastName = user?.profile?.lastName;
  const phoneDigits = String(user?.phoneNumber || '').replace(/\D/g, '');
  return Boolean(!user?.deletedAt && typeof firstName === 'string' && firstName.trim()
    && typeof lastName === 'string' && lastName.trim()
    && typeof user?.phoneNumber === 'string' && user.phoneNumber.length <= 40
    && /^[+() 0-9-]+$/.test(user.phoneNumber)
    && phoneDigits.length >= 6 && phoneDigits.length <= 15);
}
